import AadviLogo from '../assets/Aadvi-logo.png';
import './AboutAadvi.css';
import img1 from '../assets/image1.png';
import img2 from '../assets/image2.png';
import img3 from '../assets/image3.png';
import img4 from '../assets/image4.png';
import img5 from '../assets/image5.png';
import img6 from '../assets/image6.png';
import { FaPlay, FaInstagram } from "react-icons/fa";

const cardData = [
    {
        id: 1,
        imageurl: img1,
        reelurl: 'https://www.instagram.com/reel/DOlUB-MkzCM/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
        captions: "Label Aadvi\n\nIts our official\n@label_aadvi\n\nFor class Enquiry: 88074 27126"
    },
    {
        id: 2,
        imageurl: img2,
        reelurl: 'https://www.instagram.com/reel/DNLJ3_1zoFK/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
        captions: "❌sold out ❌ \nFab: semi raw silk \nTop and straight cut pant set with shawl \n\nCODE: LA005\nNeck : pattern neck \nSleeve type : scalap\n\nPant : half band half elastic with pocket\n\nLining : yes , Sleeves without lining\nSizes available: XS,S,M,L,XL ,XXL\nPrice : @1499+ $"
    },
    {
        id: 3,
        imageurl: img3,
        reelurl: 'https://www.instagram.com/reel/DMQAqdBvl1r/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
        captions: "❌sold out ❌\nCircular palazzo pant with shirt collar with v open short top.\nCustomise ur outfit with us ..🌸\n\n@label_aadvi\n\n8807427126\n\nLocation: Palladam , Tirupur"
    },
    {
        id: 4,
        imageurl: img4,
        reelurl: 'https://www.instagram.com/reel/DKy_bEzPhPV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
        captions: "Fab: pure cotton \nTop and straight cut pant set\n\nCODE: LACS 001\n Neck : collar neck\nSleeve type : high puff \nPant : half band half elastic with pocket\nLining : yes\nSleeves without lining\nSizes available: XS,S,M,L,XL \n\nPrice : @999+ $\nTo order : dm or whatsapp us\n8807427126\n\n@labe;_aadvi"
    },
    {
        id: 5,
        imageurl: img5,
        reelurl: 'https://www.instagram.com/reel/DKHlBsZvhI2/?utm_source=ig_web_copy_link',
        captions:  "Fab: pure cotton \nCODE: LAkt002\n\n Neck : close boat with horse shoe pattern Back close neck\n\n Sleeve type : puff with patti\n Lining : yes\n Sizes available: XS,S,M,L,XL\nPrice : @699 + $\n\n To order : dm or whatsapp us\n8807427126\n\n @label_aadvi"
    },
    {
        id: 6,
        imageurl: img6,
        reelurl: 'https://www.instagram.com/reel/DKCheZBPSfp/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
        captions: "Fab: pure cotton \nCODE: LAkt001\n\nNeck : close boat with v \n Back close neck\n\nSleeve type : elbow with elastic\nLining : yes \nSizes available: XS,S,M,L,XL\nPrice : @699 + $\n\nTo order : dm or whatsapp us\n8807427126\n\n@labe;_aadvi"
    }
];

function AboutAadvi() {
    const handleCardClick = (reelUrl) => {
        window.open(reelUrl, '_blank', 'noopener,noreferrer');
    };

    const formatCaption = (caption) => {
        return caption.split('\n').map((line, index) => (
            line.trim() === '' ? <br key={index} /> : <p key={index} className="caption-line">{line}</p>
        ));
    };

    return (
        <div className="about-aadvi-container">
            <div className="container my-5">
                <div className="text-center mb-4" data-aos="fade-up" data-aos-delay="100">
                    <img
                        className="navbar-brand fw-bold rounded-circle border-purple aadvi-logo"
                        src={AadviLogo}
                        alt="Aadvi Logo"
                    />
                </div>
                {/* Title Section */}           
                <div className="title-section text-center mb-5">
                    <h1 className="display-4 fw-bold mb-3">
                        <span className="purple-text">About Label Aadvi</span>
                    </h1>
                    <div className="title-border mx-auto mb-4"></div>
                </div>

                {/* Description Section */}
                <div className="description-section mb-5">
                    <p className="fs-5 fw-semibold text-muted text-center">
                        Welcome to <span className="purple-text">Label Aadvi</span>,
                        a clothing brand born from the vision and passion of{" "}
                        <span className="purple-text">Sathya Tamilselvan</span> — a creative
                        force driven by a love for style, innovation, and individuality. With
                        every design, <span className="purple-text">Sathya Tamilselvan</span>{" "}
                        brings a personal touch, blending inspiration from her journey, culture,
                        and creativity. <span className="purple-text">Label Aadvi </span>
                        is more than just apparel — its a reflection of bold ideas, timeless
                        aesthetics, and a commitment to quality.
                    </p>
                </div>

                {/* Cards Grid Section */}
                <div className="cards-grid-section">
                    <div className="row g-4 justify-content-center">
                        {cardData.map((card)     => (
                            <div
                                key={card.id}
                                className="col-6 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                            >
                                <div className="card-wrapper">
                                    {/* Card Container */}
                                    <div
                                        className="card-container position-relative overflow-hidden rounded-4 border-card"
                                        onClick={() => handleCardClick(card.reelurl)}
                                    >
                                        {/* Card Image */}
                                        <img
                                            src={card.imageurl}
                                            alt={`Label Aadvi design ${card.id}`}
                                            className="card-image w-100 h-100 object-fit-cover"
                                        />

                                        {/* Floating Play Icon - Top Right */}
                                        <div className="play-icon position-absolute top-0 end-0 m-3"
                                            style={{
                                                color: 'white',
                                                fontSize: '1.5rem',
                                                filter: 'drop-shadow(0 0 8px rgba(0, 0, 0, 0.8))',
                                                zIndex: 10,
                                                background: 'rgba(130, 39, 138, 0.8)',
                                                borderRadius: '50%',
                                                padding: '8px',
                                                width: '40px',
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'all 0.3s ease-in-out'
                                            }}
                                        >
                                            <FaPlay style={{ marginLeft: '2px' }} />
                                        </div>

                                        {/* Instagram Icon - Top Left */}
                                        <div className="instagram-icon position-absolute top-0 start-0 m-3"
                                            style={{
                                                color: 'white',
                                                fontSize: '1.2rem',
                                                filter: 'drop-shadow(0 0 8px rgba(0, 0, 0, 0.8))',
                                                zIndex: 10,
                                                background: 'rgba(0, 0, 0, 0.7)',
                                                borderRadius: '50%',
                                                padding: '8px',
                                                width: '35px',
                                                height: '35px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <FaInstagram />
                                        </div>

                                        {/* Hover Overlay */}
                                        <div 
                                            className="card-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                            style={{
                                                background: 'linear-gradient(135deg, rgba(130, 39, 138, 0.1) 0%, rgba(130, 39, 138, 0.3) 100%)',
                                                transition: 'all 0.3s ease-in-out',
                                                opacity: 0
                                            }}
                                        >
                                            <div className="view-reel-text text-white text-center"
                                                style={{
                                                    fontSize: '1.1rem',
                                                    fontWeight: '600',
                                                    textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                                                    opacity: 0,
                                                    transform: 'translateY(20px)',
                                                    transition: 'all 0.3s ease-in-out'
                                                }}
                                            >
                                                View Reel
                                            </div>
                                        </div>
                                    </div>

                                    {/* Captions Section */}
                                    <div className="card-captions mt-3 p-3 rounded-3 border-caption">
                                        <div className="caption-content">
                                            {formatCaption(card.captions)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutAadvi;